<template>
  <div>
    <b-container fluid class="p-4 footer">
      <b-row>
        <b-col>
          <h3>JFS & TTC</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm=12 md=3>
          <p>
            Corporativo JFS & TTC<br>
            San Antonio #125<br>
            Col. Las fuentes Zapopan Jal.<br>
            Guadalajara, Jalisco México<br>
            Teléfonos: 01 (33) 38105608 / 38106536
          </p>
        </b-col>
        <b-col sm=12 md=3>
          <p>
            Corporativo Tijuana<br>
            Carretera Aeropuerto<br>
            No. 3 interior 6, Garita de Otay<br>
            Tijuana, B.C México<br>
            Teléfono: (664) 9768916
          </p>
        </b-col>
        <b-col sm md=3>
          <p>
            Patio Tlaquepaque<br>
            Clz. Las delicias #84 Esq. calle progreso<br>
            Col. Alamo Oriente San Pedro Tlaquepaque<br>
            Guadalajara, Jalisco México
          </p>
        </b-col>
        <b-col sm md=3>
          <p>
            Patio San Diego<br>
            9010 Paseo de la Fuente Norte<br>
            CA 92154<br>
            San Diego, California, EEUU<br>
          </p>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col class="text-center">
          <small>
            Copyright © {{year}} JFS & TTC. Powered by <a href="">Grupo Argón</a>
          </small>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data(){
    return{
      year: new Date().getFullYear()
    }
  }
}
</script>

<style>
.footer{
  background-color: #f4f4f4;
}
h3{
  color:#3D7EAB;
}
p{
  color: #606060;
}
</style>
